import React from 'react'
import { useParams } from 'react-router-dom';
import RenewBreadCrumnb from './RenewBreadCrumb';
import RenewableAgencyTabs from './RenewableAgencyTabs';
function RenewableAgency() {
    const { plantName, id } = useParams();

    return ( 
        <>
             <RenewBreadCrumnb plantName={decodeURIComponent(plantName)} />

             <RenewableAgencyTabs plantId={id}/>

             {/* <AdvertiseBanner /> */}
        </>
     );
}

export default RenewableAgency;